import { EPaymentRequestFetchType, EPaymentRequestStatus, } from "../../types/paymentRequest.types";
import { getMessageForError } from "../../utils/error.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
export var getPaymentRequestTypes = function (fetchType) {
    switch (fetchType) {
        case EPaymentRequestFetchType.Open:
            return [EPaymentRequestStatus.New, EPaymentRequestStatus.FailedPaidIn];
        case EPaymentRequestFetchType.Pending:
            return [
                EPaymentRequestStatus.Approved,
                EPaymentRequestStatus.Pending,
                EPaymentRequestStatus.PaidIn,
                EPaymentRequestStatus.Partial,
                EPaymentRequestStatus.Transferring,
                EPaymentRequestStatus.Transferred,
                EPaymentRequestStatus.PayingOut,
                // TODO: What to do with failed statuses?
                EPaymentRequestStatus.FailedTransfer,
                EPaymentRequestStatus.FailedPayout,
                EPaymentRequestStatus.FailedKyc,
                EPaymentRequestStatus.Failed,
            ];
        case EPaymentRequestFetchType.Done:
            return [EPaymentRequestStatus.Paid];
        default:
            return [];
    }
};
export var getPaymentOrdersIdentifierForProperty = function (propertyId) {
    return propertyId ? "property-".concat(propertyId) : "";
};
export var getIbanId = function (paymentOrderId, payeeId, payerId) {
    if (payeeId) {
        return "payee-".concat(payeeId, "-").concat(paymentOrderId);
    }
    if (payerId) {
        return "payer-".concat(payerId, "-").concat(paymentOrderId);
    }
};
// The V2 update-mandate route answers 403 and 404 with one failure each, so for
// those the status identifies what happened. 422 is not one failure: it is both
// the collection that is already under way and - since DEV-3026 - the bank
// account whose mandate is not approved yet. The message is translated
// server-side, so there is no key left to match on, which is why that case is
// read off the response rather than off the status (RT-655).
var EUpdateMandateErrorStatus;
(function (EUpdateMandateErrorStatus) {
    EUpdateMandateErrorStatus[EUpdateMandateErrorStatus["Forbidden"] = 403] = "Forbidden";
    EUpdateMandateErrorStatus[EUpdateMandateErrorStatus["NotFound"] = 404] = "NotFound";
    EUpdateMandateErrorStatus[EUpdateMandateErrorStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
})(EUpdateMandateErrorStatus || (EUpdateMandateErrorStatus = {}));
/**
 * The message to show for a failed `PATCH /payment-orders/:id/update-mandate`.
 *
 * The 422 is the one the status cannot answer. Mapping it to a fixed key told
 * every payer that a payment was being collected, including the payer whose
 * chosen account simply has no approved mandate yet - copy that is neither true
 * nor actionable (RT-655). The API sends its own translated sentence for each,
 * so that one is read out of the envelope by `getMessageForError`, which also
 * falls back to the localized general error for a 422 that carries none.
 *
 * The 404 is the awkward one: a payment order that is gone, or that belongs to
 * no payment group, answers 404 as well, and reporting either as a missing bank
 * account sends the payer looking for the wrong problem. The two are told apart
 * by the envelope - the bank account lookup puts a sentence in
 * `exception.response.message`, while the shared entity-not-found exception puts
 * the status code (a number) there.
 */
export var getUpdateMandateErrorMessage = function (unknownError) {
    var _a, _b;
    var response = unknownError.response;
    switch (response === null || response === void 0 ? void 0 : response.status) {
        case EUpdateMandateErrorStatus.UnprocessableEntity:
            return getMessageForError(unknownError);
        case EUpdateMandateErrorStatus.Forbidden:
            return getLocalizedText("payment_order.update_mandate.bank_account_not_owned");
        case EUpdateMandateErrorStatus.NotFound: {
            var errorData = response.data;
            return getLocalizedText(typeof ((_b = (_a = errorData === null || errorData === void 0 ? void 0 : errorData.exception) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.message) === "string"
                ? "payment_order.update_mandate.bank_account_not_found"
                : "general.error");
        }
        default:
            return getLocalizedText("general.error");
    }
};
/**
 * @deprecated The mobile app (`rentio-app`, `ManageDirectDebits.tsx`) still
 * imports this name and wraps the result in `getLocalizedText`, which is a no-op
 * on a finished sentence. It resolves the published package through a caret
 * range, so dropping the export would break its next install. Remove once the
 * app calls `getUpdateMandateErrorMessage` (RT-655).
 */
export var getUpdateMandateErrorKey = getUpdateMandateErrorMessage;
